import { FormProvider, useForm } from "react-hook-form";
import axios from "axios";
import { message } from "antd";
import { Button, CheckboxField, InputField } from "../common";
import { ButtonType } from "../common/Button/Button";
import { ContactUsFormStyle } from "./ContactUsForm.style";
import { TextAreaField } from "../common/TextAreaField";

const ContactUsForm = () => {
  const methods = useForm({
    defaultValues: {
      name: "",
      phone: "",
      email: "",
      message: "",
      smsConsent: false,
    },
  });

  const handleFormSubmit = async (values: any) => {
    try {
      const contactData = {
        subject: "Contact",
        formType: "contact",
        name: values.name || "",
        phone: values.phone || "",
        email: values.email || "",
        message: values.message || "",
        smsConsent: values.smsConsent ? "Yes" : "No",
      };

      await axios.post("/php/mail.php", contactData, {
        headers: { "Content-Type": "application/json" },
      });

      message.success("Message sent successfully");
      methods.reset();
    } catch (error) {
      console.error("Contact form error:", error);
      message.error("Message sending failed. Please try again.");
    }
  };

  return (
    <FormProvider {...methods}>
      <ContactUsFormStyle onSubmit={methods.handleSubmit(handleFormSubmit)}>
        <InputField
          label="Name"
          name="name"
          rules={{ required: "This field is required" }}
        />
        <InputField
          label="Phone"
          name="phone"
          inputProps={{ type: "tel" }}
          rules={{ required: "This field is required" }}
        />
        <div className="single-column">
          <InputField
            label="Email"
            name="email"
            inputProps={{ type: "email" }}
            rules={{ required: "This field is required" }}
          />
        </div>
        <div className="single-column">
          <TextAreaField
            label="Message"
            name="message"
            rules={{ required: "This field is required" }}
          />
        </div>
        <div className="single-column">
          <CheckboxField
            name="smsConsent"
            label={
              <span>By checking this box, you agree to receive SMS...</span>
            }
          />
        </div>
        <Button
          className="submit-button"
          type={ButtonType.filled}
          label="Send Message"
        />
      </ContactUsFormStyle>
    </FormProvider>
  );
};
export default ContactUsForm;
